export default "__VITE_ASSET__DiBvr6ZV__"